import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA with auto-reload on update
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // When a new service worker is available, automatically reload the page
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });

      // Create a toast notification
      const toast = document.createElement('div');
      toast.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #4CAF50;
        color: white;
        padding: 16px 24px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.3);
        z-index: 10000;
        font-family: Arial, sans-serif;
        font-size: 14px;
        animation: slideIn 0.3s ease-out;
      `;
      toast.textContent = 'New version available! Refreshing in 3 seconds...';
      document.body.appendChild(toast);

      // Auto-reload after 3 seconds
      setTimeout(() => {
        window.location.reload();
      }, 3000);

      // Allow user to refresh immediately by clicking
      toast.style.cursor = 'pointer';
      toast.title = 'Click to refresh now';
      toast.onclick = () => {
        window.location.reload();
      };
    }
  },
  onSuccess: (registration) => {
    console.log('Content is cached for offline use.');
  }
});
